import { Link, useLocation } from "react-router-dom";

const linkBase = {
  color: "#0f4dcc",
  textDecoration: "none",
  padding: "6px 10px",
  borderRadius: "999px",
};
const linkActive = { ...linkBase, background: "rgba(15,77,204,0.12)", fontWeight: 600 };

function Navbar({ user, hasPendingWeeks, onLogout, onChangeManagerCode }) {
  const isManager = user?.role === "manager";
  const location = useLocation();
  const path = location.pathname || "/";
  const isActive = (to) => (to === "/" ? path === "/" : path.startsWith(to));
  return (
    <div
      className="navbar-container"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        background: "white",
        color: "#0f172a",
        boxShadow: "0 10px 25px rgba(15,23,42,0.12)",
        position: "sticky",
        top: 0,
        zIndex: 10,
      }}
    >
      <div
        style={{
          fontWeight: 700,
          letterSpacing: "0.06em",
          fontSize: "clamp(0.8rem, 2.5vw, 0.9rem)",
          textTransform: "uppercase",
          color: "#0f4dcc",
        }}
      >
        La Paix-La Grange
      </div>

      <div className="nav-links" style={{ display: "flex", alignItems: "center", gap: "16px", fontSize: "0.95rem" }}>
        <Link to="/" className="touch-target" style={{ ...(isActive("/") ? linkActive : linkBase), padding: "8px 12px" }}>
          Planning
        </Link>
        {isManager && (
          <Link to="/rapport" className="touch-target" style={{ ...(isActive("/rapport") ? linkActive : linkBase), padding: "8px 12px" }}>
            Rapport
          </Link>
        )}
        <Link to="/payroll" className="touch-target" style={{ ...(isActive("/payroll") ? linkActive : linkBase), padding: "8px 12px" }}>
          Salaires
          {hasPendingWeeks && (
            <span
              style={{
                marginLeft: "6px",
                display: "inline-block",
                width: "8px",
                height: "8px",
                borderRadius: "999px",
                background: "#dc2626",
              }}
            />
          )}
        </Link>
        {typeof onChangeManagerCode === "function" && (
          <button
            type="button"
            onClick={onChangeManagerCode}
            className="touch-target"
            style={{
              marginLeft: "4px",
              padding: "8px 12px",
              borderRadius: "999px",
              border: "1px solid #cbd5f5",
              background: "white",
              color: "#0f4dcc",
              fontSize: "0.9rem",
              fontWeight: 500,
              cursor: "pointer",
            }}
          >
            Mon code
          </button>
        )}
        {onLogout && (
          <button
            type="button"
            onClick={onLogout}
            className="touch-target"
            style={{
              marginLeft: "4px",
              padding: "8px 12px",
              borderRadius: "999px",
              border: "1px solid #e2e8f0",
              background: "white",
              color: "#64748b",
              fontSize: "0.9rem",
              cursor: "pointer",
            }}
          >
            Déconnexion
          </button>
        )}
      </div>
    </div>
  );
}

export default Navbar;
